module.exports = __webpack_public_path__ + "media/country_flags/st-ced43d76.png";